import { HelpCircle } from "lucide-react";

import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type Props = {
  label: string;
  link?: string;
  linkText?: string;
  variant?: "default" | "subtle" | "prominent";
};

export const UsageHelperBanner = ({
  label,
  link,
  linkText,
  variant = "subtle",
}: Props) => {
  const variants = {
    default: {
      container: "bg-blue-50 border-blue-200 text-blue-800",
      button: "text-blue-700 hover:text-blue-800 hover:bg-blue-100",
    },
    subtle: {
      container: "bg-muted/50 border-border text-muted-foreground",
      button: "text-muted-foreground hover:text-foreground hover:bg-muted",
    },
    prominent: {
      container: "bg-primary/5 border-primary/20 text-primary",
      button: "text-primary hover:text-primary hover:bg-primary/10",
    },
  };

  const style = variants[variant];

  return (
    <Alert className={cn("border rounded-lg py-2 px-2", style.container)}>
      <AlertDescription className="flex items-center justify-between ml-0 pl-0">
        <span className="text-sm font-medium pr-4">{label}</span>
        {link && linkText && (
          <Button
            variant="ghost"
            size="sm"
            className={cn(
              "h-auto p-1 px-2 text-xs font-normal flex-shrink-0",
              style.button,
            )}
            onClick={() => window.open(link, "_blank")}
          >
            <HelpCircle className="w-3 h-3 mr-1" />
            {linkText}
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
};
